import qs from "qs";
import { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import {userStorage} from "../utils/localStorage";
import {FileBlobResponseFields} from "../types/files/filesData";

const CONTENT_DISPOSITION_REGEX = /filename=((['"]).*?\2|[^;\n]*)/g;

const getParamsSerializer = (params: any) : string => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
}

const getResponseBody = (response: AxiosResponse) => {
    return response.data;
};

const getResponseBlobBody = (response: AxiosResponse) => {
    const matches = response.headers["content-disposition"].match(CONTENT_DISPOSITION_REGEX);
    const fileName = matches ? matches[0].replace("filename=", "") : "";

    return {
        [FileBlobResponseFields.File]: response.data,
        [FileBlobResponseFields.FileName]: fileName
    };
};

const getError = (error: AxiosError) => {
    if (error.response?.status === 401) { //Unauthorized
        userStorage.removeFromStorage();
        window.location.href = `/login`;
    }

    return Promise.reject(error.response?.data);
}

let axiosInstanceHeaders: any;

/*let tokenAutorizacion: string | null = authTokenStorage.get();
if (tokenAutorizacion != null) {
    axiosInstanceHeaders = {
        common : { 'Authorization': "Bearer " + tokenAutorizacion }
    }
}*/

export const HttpAxiosBuilder = (axiosInstance: AxiosInstance) => {
    return {
        get: async (url: string) => axiosInstance.get(url)
            .then(getResponseBody)
            .catch(getError),

        getBlob: async (url: string, params: {} = {}) => 
            axiosInstance.get(url, {responseType: 'blob', params: params})
                .then(getResponseBlobBody)
                .catch(getError),

        getWithQueryParams: async (url: string, params: {}) => axiosInstance.get(url, {params: params})
            .then(getResponseBody)
            .catch(getError),

        getWithQueryParamsSerializer: async (url: string, params: {}) => axiosInstance.get(url, {
            params: params,
            paramsSerializer: { serialize: getParamsSerializer }
        })
            .then(getResponseBody)
            .catch(getError),

        post: async (url: string, body: {}) => axiosInstance.post(url, body)
            .then(getResponseBody)
            .catch(getError),

        put: async (url: string, body: {}) => axiosInstance.put(url, body)
            .then(getResponseBody)
            .catch(getError),

        delete: async (url: string) => axiosInstance.delete(url)
            .then(getResponseBody)
            .catch(getError),

        deleteWithBody: async (url: string, body: {}) => axiosInstance.delete(url, {data: body})
            .then(getResponseBody)
            .catch(getError),

        refreshToken(newAuthToken: string) {
            axiosInstanceHeaders = {
                common: {'Authorization': "Bearer " + newAuthToken}
            }
            axiosInstance.defaults.headers = axiosInstanceHeaders;

            // axiosInstance = axios.create({
            //     baseURL: `${window.API_PROTOCOL}://${window.API_DOMAIN}/api/${window.API_VERSION}/`,
            //     timeout: window.API_TIMEOUT,
            //     headers: axiosInstanceHeaders
            // });
        },
    }
};